import { memo } from "react";

type Props = {
  svgStr: string;
  altText: string;
};

export const SVGRenderer = memo<Props>(({ svgStr, altText }) => {
  const buff = new Buffer(svgStr);
  const base64data = buff.toString("base64");

  return (
    <img
      alt={altText}
      src={`data:image/svg+xml;base64,${base64data}`}
    />
  );
});
